// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__35PbU","newExpiryDate":"styles_newExpiryDate__2j7NN","footer":"styles_footer__3RUnm"};